fx.ns("filters", class ProductLayoutFilter extends fx.Filter {

	constructor(productType)
	{
        super();

        this._productType = productType;
    }

    get productType()
    {
        return this._productType;
    }

    set productType(val)
    {
        this._productType = val;
        this._changed = true;
        this.trigger("updated");
    }

	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        for (let i = 0; i < this.rawData.length; i++)
        {
            let product = this.rawData.getItemAt( [i] );

            if (product.product_type_id != this.productType)
                continue;

            this.transformedData.push( product );
        }

		return this.transformedData;
	}	

    
});